<template>
  <li :style="{ background: '#'+(bank.rgb!=''?bank.rgb:'00A6FF') }">
    
    <!-- Three-dot Menu Button -->
    <div class="more-action" @click.stop="showDropdown = !showDropdown">⋮</div>
    
    <!-- Dropdown Menu with Animation -->
    <transition name="dropdown-anim">
      <div v-if="showDropdown" class="dropdown-menu">
        <div v-if="bank.approveStatus === 'EMPTY'" @click.stop="handleUploadProof">上传证明文件</div>
        <div class="danger-text" @click.stop="handleUnbind">解绑</div>
      </div>
    </transition>

    <!-- Unbind Confirmation Modal -->
    <div v-if="showUnbindModal" class="unbind-modal-overlay" @click.stop>
      <div class="unbind-modal-content">
        <p class="unbind-modal-title">温馨提示</p>
        <p class="unbind-modal-msg">确认要解除绑定尾数 {{ String(bank.bankAccountNumber).slice(-4) }} 的银行卡吗？</p>
        <div class="unbind-modal-actions">
          <span class="btn-cancel" @click.stop="showUnbindModal = false">取消</span>
          <span class="btn-confirm" @click.stop="confirmUnbind">確定</span>
        </div>
      </div>
    </div>

    <!-- Bank Logo and Name Row -->
    <div class="item">
      <div class="itemName">
        <em><img :src="require(`@/assets/images/bank/bank_icon/${logo}.${bank.bank === 'alipay' ? 'svg' : 'png'}`)"></em>
        <span>{{ bank.bankName }}<p>储蓄卡</p></span>
      </div>
    </div>

    <!-- Status Pill and Masked Bank Account Number Row -->
    <div class="item number-row">
      <div v-if="tabIndex == 0" class="status-text">
        <p v-if="bank.approveStatus!='APPROVAL' && bank.approveStatus!=''" 
           class="status-pill"
           :class="{
             'status-empty': bank.approveStatus === 'EMPTY',
             'status-pre': bank.approveStatus === 'PRE_APPROVAL',
             'status-cancel': bank.approveStatus !== 'EMPTY' && bank.approveStatus !== 'PRE_APPROVAL'
           }">
          {{ bank.approveStatus == "EMPTY" ? "未上传" : bank.approveStatus == "PRE_APPROVAL" ? "待审核" : bank.cancelReason }}
        </p>
      </div>
      <div class="itemNum"><p>{{ maskBankAccountNumber(bank.bankAccountNumber) }}</p></div>
    </div>
    
    <!-- Bank Branch Row -->
    <div v-if="bank" class="item bankBranch-item">
      <p style="padding-left: 1rem; display: flex; align-items: center; gap: 0.75rem;">
        <span>{{ bank.bankProvinceName }}</span>
        <span>{{ bank.bankCityName }}</span>
        <span v-if="bank.bank !== 'alipay' && bank.approveStatus=='APPROVAL' && bank.bankBranch == ''" @click.stop="$emit('edit-branch', bank.bankOrder)" style="margin-left: auto;">
          <img class="edit-icon" src="@/assets/images/bank/user_edit.png">
        </span>
        <span v-if="bank.bank !== 'alipay' && bank.bankBranch != '' && bank.approveStatus=='APPROVAL'" style="margin-left: auto;">
          {{ bank.bankBranch }}
        </span>
        <span v-else-if="bank.bank == 'alipay'" style="margin-left: auto;" />
      </p>
    </div>
  </li>
</template>

<script>
import { maskBankAccountNumber } from '@/utils/helper'

export default {
  name: 'BankListItem',
  props: {
    bank: {
      type: Object,
      required: true
    },
    logo: {
      type: String,
      required: true
    },
    tabIndex: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      showDropdown: false,
      showUnbindModal: false
    }
  },
  methods: {
    maskBankAccountNumber,
    handleUploadProof() {
      this.showDropdown = false;
      this.$emit('check-status', 'EMPTY', this.bank.bankOrder);
    },
    handleUnbind() {
      this.showDropdown = false;
      this.showUnbindModal = true;
    },
    confirmUnbind() {
      this.showUnbindModal = false;
      this.$emit('unbind', this.bank.bankOrder);
    }
  }
}
</script>

<style>
/* 
  Using an unscoped style block preserves the exact CSS selector path and specificity, 
  ensuring the text positioning and flexbox alignments don't break when migrated.
*/
.bankList .hasBankList .itemList li {
      margin: .28rem auto;
      width: 6.3rem;
      height: 3.2rem;
      box-sizing: border-box; 
      border-radius: .1rem;
      padding: .35rem .3rem; 
      position: relative; 
      display: flex; 
      flex-direction: column;
      justify-content: space-between; 
}

/* Three-dot menu toggle button */
.bankList .hasBankList .itemList li .more-action {
      position: absolute;
      right: 0.2rem;
      top: 0.2rem;
      width: 0.6rem;
      height: 0.6rem;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #fff;
      font-size: 0.45rem;
      line-height: 1;
      font-weight: bold;
      cursor: pointer;
      z-index: 5;
}

/* Dropdown Menu Container */
.bankList .hasBankList .itemList li .dropdown-menu {
      position: absolute;
      right: 0.3rem;
      top: 0.8rem;
      background: #fff;
      border-radius: 0.1rem;
      box-shadow: 0 0.05rem 0.2rem rgba(0, 0, 0, 0.15);
      z-index: 10;
      overflow: hidden;
      min-width: 2.2rem;
      transform-origin: top right;
}

/* Dropdown Animation Classes */
.dropdown-anim-enter-active, 
.dropdown-anim-leave-active {
      transition: opacity 0.2s ease, transform 0.2s ease;
}
.dropdown-anim-enter, 
.dropdown-anim-leave-to {
      opacity: 0;
      transform: scale(0.9) translateY(-0.2rem);
}

/* Dropdown Menu Items */
.bankList .hasBankList .itemList li .dropdown-menu div {
      padding: 0.2rem 0.3rem;
      font-size: 0.28rem;
      color: #333;
      text-align: center;
      border-bottom: 1px solid #f0f0f0;
      cursor: pointer;
      white-space: nowrap;
}
.bankList .hasBankList .itemList li .dropdown-menu div.danger-text {
      color: #ff3b30; /* Set the unbind text to red */
}
.bankList .hasBankList .itemList li .dropdown-menu div:last-child {
      border-bottom: none;
}
.bankList .hasBankList .itemList li .dropdown-menu div:active {
      background: #f7f7f7;
}

/* Unbind Confirmation Modal Overlay */
.bankList .hasBankList .itemList li .unbind-modal-overlay {
      position: fixed;
      top: 0;
      left: 0;
      width: 100vw;
      height: 100vh;
      background: rgba(0, 0, 0, 0.5);
      z-index: 999;
      display: flex;
      justify-content: center;
      align-items: center;
}

/* Unbind Confirmation Modal Content */
.bankList .hasBankList .itemList li .unbind-modal-content {
      width: 6.2rem; /* Increased from 5.6rem to accommodate the single-line text safely */
      background: #fff;
      border-radius: 0.2rem;
      text-align: center;
      overflow: hidden;
}

/* Modal Title */
.bankList .hasBankList .itemList li .unbind-modal-title {
      font-size: 0.36rem;
      color: #333;
      margin-top: 0.4rem;
      font-weight: bold;
}

/* Modal Message */
.bankList .hasBankList .itemList li .unbind-modal-msg {
      font-size: 0.3rem;
      color: #666;
      margin: 0.3rem 0.3rem 0.5rem;
      line-height: 1.5;
      white-space: nowrap; /* Forces text to stay on a single line */
}

/* Modal Action Buttons */
.bankList .hasBankList .itemList li .unbind-modal-actions {
      display: flex;
      border-top: 1px solid #ebebeb;
      height: 0.9rem;
      line-height: 0.9rem;
}
.bankList .hasBankList .itemList li .unbind-modal-actions span {
      flex: 1;
      font-size: 0.32rem;
      cursor: pointer;
      display: block; 
}
.bankList .hasBankList .itemList li .unbind-modal-actions .btn-cancel {
      color: #00a6ff; /* Cancel text is blue */
      border-right: 1px solid #ebebeb;
      font-weight: normal;
}
.bankList .hasBankList .itemList li .unbind-modal-actions .btn-confirm {
      color: #ff3b30; /* Confirm text is red */
      font-weight: bold;
}

.bankList .hasBankList .itemList li .item{
      width: 100%;
      overflow: hidden;
      display: flex;
      justify-content: space-between;
      align-items: center;
}

/* Vertical center alignment fixes */
.bankList .hasBankList .itemList li .number-row {
      justify-content: flex-start; 
      align-items: center; /* Vertically center the flex containers */
      margin-top: 0; 
      margin-right: 0.1rem;
}

.bankList .hasBankList .itemList li .number-row .status-text {
      display: flex;
      align-items: center;
}

.bankList .hasBankList .itemList li .number-row .itemNum {
      display: flex;
      align-items: center;
      margin-left: auto; /* Push the masked number container to the right */
}

/* Status Pill Styles */
.bankList .hasBankList .itemList li .number-row .status-pill {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      padding: 0.08rem 0.2rem; 
      border-radius: 0.3rem;
      font-size: 0.22rem;
      font-weight: bold;
      color: #fff;
      margin: 0; 
      line-height: 1; 
      box-shadow: 0 0.02rem 0.08rem rgba(0,0,0,0.1);
}

.bankList .hasBankList .itemList li .number-row .status-empty {
      background-color: #ff9800; /* Orange */
}

.bankList .hasBankList .itemList li .number-row .status-pre {
      background-color: #00b0ff; /* Blue */
}

.bankList .hasBankList .itemList li .number-row .status-cancel {
      background-color: #ff3b30; /* Red */
}

.bankList .hasBankList .itemList li .item p,
.bankList .hasBankList .itemList li .item span{
      overflow: hidden;
      display: block;
      font-size: .24rem;
      color: #fff;
}
.bankList .hasBankList .itemList li .item span{
      font-size: .32rem;
      font-weight: bold;
}
.bankList .hasBankList .itemList li .item .itemName{
      overflow: hidden;
      display: flex;
      justify-content: flex-start;
      align-items: center;
}
.bankList .hasBankList .itemList li .item .itemName p{
      margin-top: .05rem
}
.bankList .hasBankList .itemList li .item .itemName em{
      overflow: hidden;
      width: .76rem;
      height: .76rem;
      background: #fff;
      border-radius: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-right: .3rem;
}
.bankList .hasBankList .itemList li .item .itemName img{
      width: .66rem;
}
.bankList .hasBankList .itemList li .item .itemNum p{
      font-size: .42rem;
      font-weight: bold;
      letter-spacing: 0; 
      line-height: 1; 
      margin: 0; 
}
.bankList .hasBankList .itemList li .bankBranch-item{
      justify-content: start;
}
.bankList .hasBankList .itemList li .bankBranch-item p{
      width: 5rem;
      display: flex;
      justify-content: space-evenly;
}
.bankList .hasBankList .itemList li .bankBranch-item span{
      font-size: 0.25rem;
      font-weight: normal;
      display: flex;
      align-items: center;
}
.bankList .hasBankList .itemList li .bankBranch-item span img.edit-icon{
      width: 0.32rem;
      height: 0.32rem;
      margin-left: 0.15rem;
}
</style>